export class MembershipCount {
	constructor(
		public MemberCount: number,
		public NonMemberCount: number
		) {

	}
}
